import * as React from 'react';

import { BackButton } from './BackButton';
import { useStepper } from '../../context';

export type HeaderProps = {
  title: string;
  description?: React.ReactNode;
};

function Header({ title, description }: HeaderProps) {
  const { currentStep, stepsLength } = useStepper();

  return (
    <header className='flex flex-col'>
      <BackButton />
      <span className='mt-2 mb-1 text-[10px] font-bold text-[#78909C] uppercase' aria-valuenow={currentStep}>
        Passo {currentStep} de {stepsLength}
      </span>
      <h2 id='step-title' className='mb-2 text-[32px] leading-[1.2] font-semibold text-[#072D83]'>
        {title}
      </h2>
      {description && <p className='text-base text-[#546E7A]'>{description}</p>}
    </header>
  );
}

export { Header };
